import React from "react";
import { AWS_S3_URL, FIREBASE_STORAGE_URL } from "utils/constants";

function GalleryItem({ image, eventName, areaName, openLightbox }) {
  return (
    <div
      className="gallery-container overflow-hidden m-1 cursor-pointer"
      style={{ gridArea: areaName }}
      onClick={() => openLightbox({ url: image, caption: eventName })}
    >
      <figure className="gallery-thumb relative h-full">
        <img
          src={`${FIREBASE_STORAGE_URL}gallery-22%2F${
            image.split(".")[0]
          }.jpg?alt=media`}
          alt=""
          className="gallery-img block w-full h-full"
          onError={(e) => onImageLoadErrorHandler(e, image)}
        />
        <figcaption className="gallery-caption opacity-0 absolute bottom-0 left-0 w-full pt-[25px] pl-[15px] pr-[15px] pb-[10px] text-lg text-gray-50 ">
          {eventName}
        </figcaption>
      </figure>
    </div>
  );
}

export default GalleryItem;

const onImageLoadErrorHandler = (event, image) => {
  if (event) event.target.src = `${AWS_S3_URL}gallery22/${image}`;
};
